// @ts-nocheck
import React, { useContext, useEffect } from "react";
import { HexpertContext } from "../../contexts/HexPertProvider";
import { HexpertResultSummaryData } from "../../types/hexpertResultTypes";
import { Button } from "../Buttons";
import './ProductSummary.scss';

type ProductSummaryProps = {
  buttonAction: any;
  data: HexpertResultSummaryData;
  typeName?: string;
  resultIcon?: string;
};

export const ProductSummary = ({
  buttonAction,
  data,
  typeName,
  resultIcon,
}: ProductSummaryProps) => {
  const { dispatch, state } = useContext(HexpertContext);
  const makeColumns = () => {
    const columns = new Set(data.FormDataItems.map((item) => item.Slide));
    return Array.from(columns);
  };

  const currentForm = state.pageProps?.MappedForms?.find(
    (form) => form?.formGuid === state.productResult?.FormGuid
  );

  useEffect(() => {
    dispatch({
      type: "setForceSteps",
      payload:
        makeColumns()?.filter((column) => {
          const showColumn = data.FormDataItems.filter(
            (item) => item.Slide === column && item?.FieldValue?.length > 0
          )?.length;
          return showColumn;
        })?.length + 1,
    });
    dispatch({ type: "submitOnNext", payload: true });
  }, [data.FormDataItems]);
  return (
    <div className="c-hex-result-summary">
      <div className="c-hex-result-summary-top-wrapper">
        <div className="c-hex-result-summary-top-wrapper-left">
        {/* Story 463554: Maintain structured H tags.<h4> to <h3> to improve heading hierarchy and maintain proper structure */}
          <h3 className="c-hex-result-summary-top-header">
            {data?.LocalizedTranslationResources?.WefitBlockPosition}
          </h3>
          <div className="c-hex-result-summary-heater-cooler-wrapper">
            <img src={resultIcon} alt={typeName} />
            <h4 className="c-hex-result-summary-question">{typeName}</h4>
          </div>
        </div>
        <div className="c-hex-result-summary-top-wrapper-right-desktop">
          <Button label={data?.LocalizedTranslationResources?.WeFitEditProjectData} action={buttonAction} />
        </div>
      </div>
      <hr className="c-hex-result-summary-divider" />
      <div className="c-hex-result-summary-bottom-wrapper">
        {makeColumns()?.map((column) => {
          const showColumn = data.FormDataItems.filter(
            (item) => item.Slide === column && item?.FieldValue?.length > 0
          )?.length;
          return showColumn ? (
            <div className="c-hex-result-summary-column" key={column}>
              <h4 className="c-hex-result-summary-headers">{column}</h4>
              {data.FormDataItems?.filter((item) => item.Slide === column)?.map(
                (item) => {
                  const mapValueFromBlock =
                    state.pageProps?.fieldsToCheckInResult?.includes(
                      item?.FieldName
                    );
                  let answerCaption = "";
                  if (mapValueFromBlock) {
                    currentForm.sections?.forEach((section) =>
                      section.questions?.forEach((question) => {
                        if (question.FieldId === item?.FieldName) {
                          answerCaption = question?.Options?.find(
                            (option) => option.Value === item?.FieldValue
                          )?.Caption;
                        }
                      })
                    );
                  }
                  return item?.FieldValue?.length > 0 ? (
                    <div key={item.Field}>
                      <p className="c-hex-result-summary-question">
                        {item.Label}
                      </p>
                      <p className="c-hex-result-summary-answer">
                        {answerCaption?.length > 0
                          ? answerCaption
                          : item.FieldValue}{" "}
                        {item?.unit}
                      </p>
                    </div>
                  ) : null;
                }
              )}
            </div>
          ) : null;
        })}
      </div>
      <div className="c-hex-result-summary-top-wrapper-right-mobile-tablet">
        <Button
          label={data?.LocalizedTranslationResources?.WeFitEditProjectData}
          action={buttonAction}
        />
      </div>
    </div>
  );
};
